import styled from 'styled-components'
import {Input, Layout} from 'antd'


export const Wrapper = styled.div`
    //display: inline-flex;
    //align-content: space-between;
    //width: 100%;
    //flex-wrap: wrap;
`

export const MenuItemTitle = styled.span`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`